const scrollToElement = ({ scrollableElement, targetElement, scrollType = "instant", offsetTop = 100 }) => {
  if (scrollableElement && targetElement) {
    const containerRect = scrollableElement.getBoundingClientRect()
    const targetRect = targetElement.getBoundingClientRect()

    const scrollTop = targetRect.top - containerRect.top + scrollableElement.scrollTop - offsetTop

    scrollableElement.scrollTo({
      top: scrollTop,
      behavior: scrollType,
    })
  }
}

export default scrollToElement
